import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import VuexEasyFirestore from 'vuex-easy-firestore';

import companies from './store/companies/companies';
import users from './store/users/users';
import root from './store/root/root';
import unloading from './store/unloading/unloading';

import customers from './store/customers/customers';
import products from './store/products/products';
import locations from './store/locations/locations';
import cargo from './store/cargos/cargo';
import incomingCargo from './store/incoming-cargos/cargo';
import outgoingCargoProgress from './store/cargos-progress/cargoProgress';
import deviations from './store/deviations/deviations';
import orders from './store/orders/orders';
import orderProducts from './store/order-products/orderProducts';
import pickLocations from './store/pick-locations/pickLocations';
import incomingOrderProducts from './store/incoming-order-products/incomingOrderProducts';
import incomingOrders from './store/incoming-orders/incomingOrders';
import {firebase} from './init/firebase';
import dayStats from "./store/day-stats/daystats";
import deviationFixerQueue from "./store/deviation-fixer-queue/deviationFixerQueue";
import batchUnload from "./store/batch-unload/batchUnload";
import dockSuggestions from "./store/dock-suggestions/docksuggestions";
import cylcecount from "./store/cyclecount/cyclecount";
import appstatus from "./store/appstatus/appstatus";
import userData from "./store/user-data/userData";

const easyFirestore = VuexEasyFirestore(
    [
      products,
      locations,
      cargo, orders, orderProducts,
      customers,
      pickLocations,
      outgoingCargoProgress,
      deviations,
      dayStats,
      deviationFixerQueue,
      batchUnload,
      dockSuggestions,
      cylcecount,
      appstatus,
      userData,
      incomingCargo, incomingOrders, incomingOrderProducts],
    {logging: process.env.NODE_ENV !== 'production', FirebaseDependency: Vue.prototype.$FBClient}
);

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: false,
    oAuthToken: null,
    loadingTypes: [],
    loadingCargoId: null
  },
  getters: {
    getLoadingTypes: state => state.loadingTypes,
    getLoadingScreen: state => state.loading,
    getShowMenu: state => state.showMenu,
    getToken: state => state.oAuthToken,
    getLoadingCargoId: state => state.loadingCargoId,
    getAPICompanyID: (state) => {
      if(state.root.MockCompanyID > 1) {
        return state.root.MockCompanyID;
      } else {
        return state.users.me.company.id;
      }
    }
  },
  mutations: {
    setLoadingTypes(state, payload) {
      if(!_.includes(state.loadingTypes, payload)) {
        state.loadingTypes.push(payload);
      } else {
        var index = _.findIndex(state.loadingTypes, (item) => {
          return payload === item;
        });
        state.loadingTypes.splice(index, 1);
      }
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLoadingCargoId(state, payload) {
      state.loadingCargoId = payload;
    },
    setOauthToken(state, payload) {
      state.oAuthToken = payload;
    }
  },
  actions: {
    async initDataForPage({dispatch, commit, state, getters}, payload) {
      commit('setLoading', true);
      const companyId = parseInt(getters.getAPICompanyID);

      let promises = [];
      _.each(payload, moduleName => {
        if(moduleName.module && moduleName.where) {
          let where = [
            ['companyId', '==', companyId],
            moduleName.where
          ];
          if (Array.isArray(moduleName.where[0])) {
            moduleName.where.forEach(nestedWhere => {  where.push(nestedWhere) });
          } else {
            where.push(moduleName.where);
          }
          promises.push(dispatch(moduleName.module + '/openDBChannel', {where}));
        } else {
          let where = [['companyId', '==', companyId]];
          promises.push(dispatch(moduleName + '/openDBChannel', {where}));
        }
      });

      return Promise.all(promises).then((e) => {
        commit('setLoading', false);
      }).catch((e) => {
        console.error('errors here', e);
        commit('setLoading', false);
      });
    },
    resetStoreModules({dispatch, commit, state, getters}, payload) {
      let promises = []
      _.each(payload, moduleName => {
        promises.push(dispatch(moduleName + '/closeDBChannel',{clearModule:true}))
      });
      return Promise.all(promises)
    },
    initApp({dispatch, commit, state, getters}, payload) {
      let companyId = getters.getAPICompanyID;


      Promise.all([
        dispatch('initDataForPage', ['cargo','incomingCargo','customers','locations', 'appstatus']),
        // dispatch('locations/fetchAndAdd',{where , limit: 0 })
        // dispatch('cargo/openDBChannel', {where}),
        // dispatch('cargo/openDBChannel', {where})
      ]).catch(e=>{
        console.log(e)
      })
      setConfig(companyId.toString()).then((config) => {
        Vue.prototype.$APP_CONFIG = config;

      });
    }
  },
  modules: {
    unloading,
    companies,
    users,
    root // is always used for the motivaters (employees of motivate)
  },
  plugins: [
    easyFirestore,
    createPersistedState({
      paths: ['users', 'oAuthToken', 'loadingCargoId']
    })]
});


/**
 * getting company config
 * returns the config settings for given company
 * @param companyId
 * @returns {Promise<firebase.firestore.DocumentData>}
 */
var setConfig = function (companyId) {
  return firebase.firestore().collection('config').doc(companyId).get().then(res => {
    return res.data();
  });
};
